<template>
  <component :is="tag" class="fw-bold" :class="[
    withMb ? 'mb-4' : 'm-0'
  ]"><slot />
  </component>
</template>

<script>
export default {
  props: {
    withMb: Boolean,
    tag: {
      type: String,
      default: 'h4'
    }
  }
}
</script>

<style>

</style>